//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Multiselect from '../Multiselect.vue';
import ProductTeaser from '../Partials/ProductTeaser/ProductTeaser.vue';

const normalizeFieldValue = (fieldType, value) => {
    if (fieldType === 'price') return value.match(/^([\d\.]*)/)[1];

    return value.toUpperCase();
};

export default {
    name: 'ProductList',
    components: { ProductTeaser, Multiselect },
    props: ['data', 'isConfiguratorList', 'searchTerm'],
    mixins: [require('../../mixins/product_range.js').default],
    data() {
        let filters = {
            installationType: this.$route.query?.installationType ?? [],
            shape: this.$route.query?.shape ?? [],
            functions: this.$route.query?.functions ?? [],
            dimensions: this.$route.query?.dimensions ?? [],
        };

        if (this.data?.category?.length) {
            const split = this.data.category.split(',');
            if (split.includes('2215') || split.includes('2217')) {
                filters = {
                    accessoryCategory: this.$route.query?.accessoryCategory ?? [],
                    suitableFor: this.$route.query?.suitableFor ?? [],
                };
            }
        }
        Object.keys(filters).forEach((filterKey) => {
            if (!Array.isArray(filters[filterKey])) {
                filters[filterKey] = [filters[filterKey]];
            }
        });

        return {
            filters,
            currentFlyout: null,
            runFetch: true,
            products: [],
            pageSize: 9,
            page: 1,
            selectedDimensionWidth: null,
            selectedDimensionHeight: null,
            selectedDimensionLength: null,
            dimensionWidthOptions: [],
            dimensionHeightOptions: [],
            dimensionLengthOptions: [],
            specialTeaserList: [],
            screenWidth: null,
        };
    },
    async fetch() {
        try {
            if (this.data?.category && this.$nuxt.context.app.api.product) {
                const categories = this.data?.category?.split(',').map((cat) => parseInt(cat, 10));

                // Get products by category id
                let products = [];
                for (const cat of categories) {
                    let p = await this.$nuxt.context.app.api.product.getProductsByCategoryId(cat, this.$i18n.locale);
                    products = products.concat(p);
                }

                this.initProducts(products);
            } else {
                this.runFetch = false;
            }
        } catch (e) {
            //this.$nuxt.context.res.statusCode = 500;
            throw new Error(e + ' - ' + this.$nuxt.context.route.fullPath);
        }
    },
    computed: {
        specialTeasers() {
            return this.specialTeaserList.length;
        },
        productRange() {
            return this.getSelectedProductRange().toLowerCase();
        },
        loadMoreButtonLabel() {
            return `${this.$t('loadmore')} (${this.itemAmount - this.currentLimit})`;
        },
        itemAmountString() {
            return this.$tc('product.filter.products', this.itemAmount, { n: this.itemAmount });
        },
        itemAmount() {
            return this.filtered?.length;
        },
        pageSizeAdjustment() {
            //mobile
            if (this.isMobile) return 0;
            //Tablet in Portrait mode --> 2 cols
            if (this.isTablet && this.screenWidth && this.screenWidth < 1024) return (this.page * this.pageSize + this.specialTeasers) % 2;
            // Other Devices --> 3 Cols
            if (this.specialTeasers % 3 === 0) return 0;
            return (this.page * this.pageSize + this.specialTeasers) % 3 === 1 ? 2 : 1;
        },
        currentLimit() {
            return this.page * this.pageSize + this.pageSizeAdjustment;
        },
        isTablet() {
            return !!this.$mobileDetect.tablet();
        },
        isMobile() {
            return !this.$mobileDetect.tablet() && !!this.$mobileDetect.mobile();
        },
        filtered() {
            let { products } = this;

            //filter by bubbles
            Object.keys(this.filters).forEach((filterKey) => {
                if (!this.filters?.[filterKey]?.length) return;

                const filter = this.filters[filterKey].map((o) => normalizeFieldValue(filterKey, o));
                products = products.filter((product) => {
                    const productFields = product[`cannonical_${filterKey}`]?.split(',').map((o) => normalizeFieldValue(filterKey, o));
                    if (!productFields) return false;

                    return filter.every((value) => productFields.includes(value));
                });
            });

            //filter by dimensions
            products = products.filter((p) =>
                p.variants.some((v) => {
                    return (
                        (this.selectedDimensionWidth ? v.width === this.selectedDimensionWidth?.value : true) &&
                        (this.selectedDimensionHeight ? v.height === this.selectedDimensionHeight?.value : true) &&
                        (this.selectedDimensionLength ? v.length === this.selectedDimensionLength?.value : true) &&
                        (this.searchTerm ? v.externalKey === this.searchTerm || p.name.toLowerCase().includes(this.searchTerm.toLowerCase()) : true)
                    );
                })
            );

            return products;
        },
        limitedProducts() {
            const limited = this.filtered.slice(0, this.currentLimit);
            return this.sortFiltered(limited);
        },
    },
    async mounted() {
        document.addEventListener('click', (e) => {
            this.$nextTick(() => {
                if (this.currentFlyout) {
                    if (!e.target.closest(`.productlist__filtercategory--${this.currentFlyout}`)) {
                        this.setCurrentFlyout(null);
                    }
                }
            });
        });
        this.screenWidth = window.screen.width;
    },
    methods: {
        addSpecialTeaser(value) {
            if (this.specialTeaserList.indexOf(value) !== -1) return;
            this.specialTeaserList.push(value);
        },
        sortFiltered(limitedArray) {
            if (this.specialTeasers === 0) return limitedArray;
            if (this.isTablet && window.screen.width < 1024) {
                return this.switchObjects(limitedArray, 2) ?? limitedArray;
            }
            if (this.isMobile) {
                return limitedArray;
            }
            return this.switchObjects(limitedArray, 3) ?? limitedArray;
        },
        switchObjects(arr, cols) {
            if (!arr?.length) return null;
            let prevTeasers = [];
            for (let i = 0; i < arr.length; i++) {
                if (this.specialTeaserList.includes(arr[i].id)) {
                    if (prevTeasers.indexOf(arr[i].id) === -1) {
                        prevTeasers.push(arr[i].id);
                    }
                    if (!i) continue;

                    let adjustment = prevTeasers.length - 1;
                    if ((i + adjustment + 1) % cols !== 0) continue;
                    let j = this.getNextSimpleProductIndex(arr, i);
                    if (!j) continue;
                    arr.splice(i, 0, arr[j]);
                    arr.splice(j + 1, 1);
                }
            }

            return arr;
        },
        getNextSimpleProductIndex(arr, i) {
            for (let j = i + 1; j < arr.length; j++) {
                if (!this.specialTeaserList.includes(arr[j].id) && !arr[j].hasLandingPage) {
                    return j;
                }
            }
            return null;
        },
        initProducts(products) {
            if (products.length) {
                let productsVariants = [];

                products = products.filter((p) => {
                    return this.isInProductRange(p);
                });

                if (this.data['installationVariant']) {
                    productsVariants = products.filter((p) => {
                        return p.variants.find((v) => v.installationVariant === this.data['installationVariant']);
                    });
                }

                // Pre-filter products by available filters
                Object.keys(this.filters).forEach((filter) => {
                    if (this.data[filter]) {
                        products = products.filter((p) => {
                            if (Array.isArray(this.data[filter])) {
                                return !!this.data[filter].find((f) => p[`cannonical_${filter}`]?.split(',').includes(f));
                            }
                            return p[`cannonical_${filter}`]?.split(',').includes(this.data[filter].trim());
                        });
                    }
                });

                // sort by prio field
                this.products = [...products, ...productsVariants].sort((a, b) => {
                    return a.prio - b.prio;
                });

                // show or hide load more button
                if (this.data.loadmore !== true) {
                    this.pageSize = this.products.length;
                }

                // Adjust filter-preset by available product properties / filterfields
                Object.keys(this.filters).forEach((filter) => {
                    if (!products.some((p) => p[`cannonical_${filter}`] && p[`cannonical_${filter}`].length > 0) && filter !== 'dimensions') {
                        delete this.filters[filter];
                    }
                });
                this.setDimensionFilters();
            }
        },
        setDimensionFilters() {
            // set dimensions filter
            if (this.products && this.products.length) {
                this.products.forEach((p) => {
                    p.variants.forEach((v) => {
                        if (!this.dimensionWidthOptions.some((dwo) => dwo.value === v.width)) {
                            this.dimensionWidthOptions.push({
                                label: `${v.width} ${this.$i18n.t('dimensions.units')}`,
                                value: v.width,
                            });
                        }
                        if (!this.dimensionHeightOptions.some((dwo) => dwo.value === v.height)) {
                            this.dimensionHeightOptions.push({
                                label: `${v.height} ${this.$i18n.t('dimensions.units')}`,
                                value: v.height,
                            });
                        }
                        if (!this.dimensionLengthOptions.some((dwo) => dwo.value === v.length)) {
                            this.dimensionLengthOptions.push({
                                label: `${v.length} ${this.$i18n.t('dimensions.units')}`,
                                value: v.length,
                            });
                        }
                    });
                });
            }

            function compareNumbers(a, b) {
                return a.value - b.value;
            }

            this.dimensionWidthOptions.sort(compareNumbers);
            this.dimensionHeightOptions.sort(compareNumbers);
            this.dimensionLengthOptions.sort(compareNumbers);
        },
        // toggle Filter and filter products
        toggleFilter(filter, filterField) {
            if (this.filters[filterField].includes(filter)) {
                this.filters[filterField].splice(this.filters[filterField].indexOf(filter), 1);
            } else {
                this.filters[filterField].push(filter);
            }

            // update url search params
            if (process.client) {
                this.$router.replace({ path: this.$route.path, query: this.filters });
            }
            this.page = 1;
        },

        // toggle filter flyout
        setCurrentFlyout(filterField) {
            if (this.currentFlyout !== filterField) {
                this.currentFlyout = filterField;
            } else {
                this.currentFlyout = null;
            }
        },

        getSetByKey(key) {
            let list = [];
            this.products.forEach((item) => {
                if (item[key]) {
                    list.push(item[key].split(','));
                }
                list = [...new Set(list.flat(2))];
            });
            list = list.sort((a, b) => a.localeCompare(b, this.$i18n.locale, { ignorePunctuation: true }));
            return list;
        },

        getCannonicalFilterLabel(label, filterField) {
            const key = `cannonical_${filterField}`;
            const product = this.products?.find((p) => p?.[filterField]?.split(',').includes(label));
            const index = product?.[filterField]?.split(',').indexOf(label);
            const cannonical = product?.[key]?.split(',')[index];
            return cannonical;
        },

        getLocalizedFilterLabel(label, filterField) {
            const key = `cannonical_${filterField}`;
            const product = this.products?.find((p) => p?.[key]?.split(',').includes(label));
            const index = product[key].split(',').indexOf(label);
            const localized = product?.[filterField]?.split(',')[index];
            return localized;
        },
    },
};
